import {useAxios} from "@/utils/useAxios";

const api = {

    /**
     * 로그아웃
     * @param params
     * @returns {Promise<void>}
     */
    async getLogout() {
        const {execute} = await useAxios("/cmm/api/v1/member/getLogout", {}, {
            exceptionThrow: true
        });
        await execute();
    },

    /**
     * 로그인
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async nxKeyDecode(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/member/getLogin/e2e", {}, {
            exceptionThrow: true,
            loading: true
        });
        await execute(params);

        return data.value
    },
    /**
     * 소셜 로그인
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async getOauthLogin(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/member/getLogin");
        await execute(params);
        return data.value
    },
    /**
     * 라온시큐어 - 서버 랜덤 난수 값을 받아옴
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async getTNKSR() {
        const {data, execute} = await useAxios("/cmm/getTNKSR", {}, {
            exceptionThrow: true
        });
        await execute();
        return data.value
    },

    async getTNKSR2() {
        const {data, execute} = await useAxios("/cmm/raonnx/transKey/jsp/nonce", {}, {
            exceptionThrow: true
        });
        await execute();
        return data.value
    },

    /**
     * 공동인증서 로그인
     * @param params
     * @returns {Promise<Ref<UnwrapRef<null>>>}
     */
    async ksbizLoginAction(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/member/getCertOfficialLogin", {
            headers: {'Content-Type': 'multipart/form-data'},
        }, {
            exceptionThrow: true,
            loading: true
        });
        const formData = new FormData();
        formData.append('ksbizSig', params.data);
        formData.append('nonceToken', params.nonceToken);
        await execute(formData);
        return data.value
    },

    /**
     * 금융인증서 로그인
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async ksbizFinanceLoginAction(params, context) {
        const {data, execute} = await useAxios("/cmm/api/v1/member/getCertFinanceLogin", {
            headers: {'Content-Type': 'multipart/form-data'},
        }, {
            exceptionThrow: true,
            loading: true
        });
        const formData = new FormData();
        formData.append('nonce', context);
        formData.append('ksbizSig', params.data);
        await execute(formData);
        return data.value
    },

    /**
     * ID 찾기
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async getId(params) {
        const {data, error, execute} = await useAxios("/cmm/api/v1/usr/getId", {}, {
            exceptionThrow: true
        });
        await execute(params);
        return data.value.result;
    },

    /**
     * (비로그인) 공동인증서 인증후 비밀번호 초기화에 필요한 토큰요청
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async verifyCertOfficial(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/verifyCertOfficial", {
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        }, {
            exceptionThrow: true,
            loading: true
        });
        // 받은 params값을 formData로 변형
        const formData = new FormData();
        formData.append('ksbizSig', params.data);
        formData.append('nonceToken', params.nonceToken);
        await execute(formData);
        return data.value;
    },

    /**
     * (비로그인) 금융인증서 인증후 비밀번호 초기화에 필요한 토큰요청
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async verifyCertFinance(params, context) {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/verifyCertFinance", {
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        }, {
            exceptionThrow: true,
            loading: true
        });
        // 받은 params값을 formData로 변형
        const formData = new FormData();
        formData.append('nonce', context);
        formData.append('ksbizSig', params.data);
        await execute(formData);
        return data.value;
    },

    /**
     * (비로그인) 간편인증 인증 후 비밀번호 초기화에 필요한 토큰요청
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async verifyCertSimple(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/verifyCertSimple", {}, {
            exceptionThrow: true,
            loading: true
        });
        await execute(params);
        return data.value;
    },

    /**
     * (비로그인) 휴대폰인증 인증 후 비밀번호 초기화에 필요한 토큰요청
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async verifyCellPhone(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/verifyCellPhone", {}, {
            exceptionThrow: true,
            loading: true
        });
        await execute(params);
        return data.value;
    },

    /**
     * (비로그인) 아이핀 인증 후 비밀번호 초기화에 필요한 토큰요청
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async verifyIPin(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/verifyIPin", {}, {
            exceptionThrow: true,
            loading: true
        });
        await execute(params);
        return data.value;
    },

    /**
     * (로그인) 굼융인증서 인증후 비밀번호 초기화에 필요한 토큰요청
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async verifyMyCertFinance(params, context) {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/verifyMyCertFinance", {
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        }, {
            exceptionThrow: true,
            loading: true
        });
        // 받은 params값을 formData로 변형
        const formData = new FormData();
        formData.append('nonce', context);
        formData.append('ksbizSig', params.data);
        await execute(formData);
        return data.value;
    },

    /**
     * (로그인) 공동인증서 인증후 비밀번호 초기화에 필요한 토큰요청
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async verifyMyCertOfficial(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/verifyMyCertOfficial", {
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        }, {
            exceptionThrow: true,
            loading: true
        });
        // 받은 params값을 formData로 변형
        const formData = new FormData();
        formData.append('ksbizSig', params.data);
        formData.append('nonceToken', params.nonceToken);
        await execute(formData);
        return data.value;
    },

    /**
     * 비로그인 [공인, 금융] 인증후 비밀번호 초기화 (토큰값으로 비밀번호 변경)
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async resetPassword(params) {

        const {data, execute} = await useAxios("/cmm/api/v1/usr/resetPassword", {}, {
            exceptionThrow: true
        });
        await execute(params);
        return data.value.result;
    },

    /**
     * 로그인 인증후 비밀번호 초기화 (토큰값으로 비밀번호 변경)
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async setPassword(params) {

        const {data, execute} = await useAxios("/cmm/api/v1/usr/setPassword", {}, {
            exceptionThrow: true
        });

        await execute(params);
        return data.value;
    },

    /**
     * 공인 인증서 조회
     *
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async getCertOfficialLoginList(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/member/getCertOfficialLoginList")
        await execute(params);
        return data.value.result
    },

    /**
     * 공인 인증서 삭제
     *
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async delCertOfficialLogin(params) {
        const {execute} = await useAxios("/cmm/api/v1/member/delCertOfficialLogin", {}, {
            exceptionThrow: true
        });
        await execute(params);
    },

    /**
     * 소셜 로그인 등록 링크 (팝업창)
     * @param params
     * @param provider
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async setSnsLoginLink(params) {
        const {data, execute} = await useAxios('/cmm/api/v1/member/getSnsLoginRegisterLink');
        await execute(params);
        return data.value;
    },

    /**
     * 소셜로그인 등록1 (카카오, 네이버, 구글)
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async setSnsLogin(params) {
        const {data, execute} = await useAxios('/cmm/api/v1/member/setSnsLogin', {}, {
            exceptionThrow: true,
        });
        await execute(params);
        return data.value;
    },

    /**
     * 소셜로그인 등록2 (애플전용)
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async setSnsLoginApple(params) {
        const {data, execute} = await useAxios('/cmm/api/v1/member/setSnsLogin/apple', {}, {
            exceptionThrow: true,
        });
        await execute(params);
        return data.value;
    },

    /**
     * 소셜 로그인 삭제
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async delSnsLogin(params) {
        const {data, execute} = await useAxios('/cmm/api/v1/member/delSnsLogin', {}, {
            exceptionThrow: true,
        });
        await execute(params);
        return data.value;
    },

    /**
     * 소셜 로그인 링크
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async getSnsLoginLink(params) {
        const {data, execute} = await useAxios('/cmm/api/v1/member/getSnsLoginLink');
        await execute(params);
        return data.value;
    },

    /**
     * 소셜 로그인 (카카오, 네이버, 구글)
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async getSnsLogin(params) {
        const {data, execute} = await useAxios('/cmm/api/v1/member/getSnsLogin', {}, {
            exceptionThrow: true,
        });
        await execute(params);
        localStorage.setItem('lastSnsLogin', params.provider);
        return data.value;
    },

    /**
     * 소셜 로그인 (애플전용)
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async getSnsLoginApple(params) {
        const {data, execute} = await useAxios('/cmm/api/v1/member/getSnsLogin/apple', {}, {
            exceptionThrow: true,
        });
        await execute(params);
        return data.value;
    },
    /**
     * 휴대폰인증 sci에 전달할 파람값 셋팅
     * @returns {Promise<*>}
     */
    async getPCCInput(params) {
        const {data, execute} = await useAxios('/cmm/api/v1/sci/pcc/request', {}, {
            exceptionThrow: true,
            loading : true
        });
        await execute(params);
        return data.value
    },
    /**
     * 아이핀 sci에 전달할 파람값 셋팅
     * @returns {Promise<*>}
     */
    async getCBAInput(params) {
        const {data, execute} = await useAxios('/cmm/api/v1/sci/cba/request', {}, {
            exceptionThrow: true,
            loading: true,
        });
        await execute(params);
        return data.value
    },

    /**
     * 실명인증 요청
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async getNameInput(params) {
        const {data, execute} = await useAxios('/cmm/api/v1/sci/name/request', {}, {
            exceptionThrow: true,
        });
        await execute(params);
        return data.value.result;
    },

    /**
     * 휴대폰인증 로그인
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async getCellPhoneLogin(params) {
        const {data, execute} = await useAxios('/cmm/api/v1/member/getCellPhoneLogin', {}, {
            exceptionThrow: true,
            loading: true
        });
        await execute(params);
        return data.value
    },

    /**
     * 간편인증 로그인
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async getSimpleLogin(params) {
        const {data, execute} = await useAxios('/cmm/api/v1/member/getSimpleLogin', {}, {
            exceptionThrow: true,
            loading: true
        });
        await execute(params);
        return data.value
    },

    /**
     * 아이핀 로그인
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async getIPinLogin(params) {
        const {data, execute} = await useAxios('/cmm/api/v1/member/getIPinLogin', {}, {
            exceptionThrow: true,
            loading: true
        });
        await execute(params);
        return data.value
    },

    /**
     * 로그인 환경 휴대폰 본인인증
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async verifyMyCellPhone(params) {
        const {data, execute} = await useAxios('/cmm/api/v1/usr/verifyMyCellPhone', {}, {
            exceptionThrow: true,
            loading: true
        });
        await execute(params);
        return data.value
    },

    /**
     * 로그인 환경 아이핀 본인인증
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async verifyMyIPin(params) {
        const {data, execute} = await useAxios('/cmm/api/v1/usr/verifyMyIPin', {}, {
            exceptionThrow: true,
            loading: true
        });
        await execute(params);
        return data.value
    },

    /**
     * 로그인 환경 간편인증 본인인증
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async verifyMyCertSimple(params) {
        const {data, execute} = await useAxios('/cmm/api/v1/usr/verifyMyCertSimple', {}, {
            exceptionThrow: true,
            loading: true
        });
        await execute(params);
        return data.value
    },

    /**
     * 회원 전화번호 등록/수정
     * @param params
     * @returns {Promise<null extends ShallowRef<infer V> ? V : (null extends Ref<infer V> ? UnwrapRefSimple<V> : UnwrapRefSimple<null>)>}
     */
    async setMpno(params) {
        const {data, execute} = await useAxios('/cmm/api/v1/usr/setMpno', {}, {
            exceptionThrow: true,
        });
        await execute(params);
        return data.value
    },

    /**
     * 비로그인 휴대폰 아이핀 교차 인증
     * @param params
     * @returns {Promise<*>}
     */
    async verifyCellPhoneAndIPin(params) {
        const {data, execute} = await useAxios('/cmm/api/v1/usr/verifyCellPhoneAndIPin');
        await execute(params);
        return data.value.result
    },

    /**
     * 개인정보 중복체크
     * @param params
     * @returns {Promise<*>}
     */
    async getCiExist(params) {
        const {data, execute} = await useAxios('/cmm/api/v1/usr/getCiExist');
        await execute(params);
        return data.value
    },
}

export default api;